















import { Validator } from 'vee-validate'
import Vue from 'vue'
import { Component, Emit, Inject, Prop } from 'vue-property-decorator'

@Component
export default class CardOwnerForm extends Vue {
  @Inject()
  $validator: Validator

  @Prop({ default: '' })
  value: string

  @Emit('input')
  onInput(_value: string): void {
    // Do nothing
  }
}
